/* eslint-disable max-len */

import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default () => (
  <SvgIcon viewBox='0 0 7 7' style={{ height: 7, width: 7 }}>
    <g id='Сгруппировать_2491' data-name='Сгруппировать 2491' transform='translate(0.5 0.5)'>
      <path id='Контур_13721' data-name='Контур 13721' d='M599-1440v6' transform='translate(-596 1440)' fill='none' stroke='#1685fc' strokeLinecap='round' strokeWidth='1' />
      <path id='Контур_13722' data-name='Контур 13722' d='M0,0V6' transform='translate(6 3) rotate(90)' fill='none' stroke='#1685fc' strokeLinecap='round' strokeWidth='1' />
    </g>
  </SvgIcon>
);
